import style, { loginError, providerStyle } from '../../styles/components/componentMap/live'
import VideoPlayer from '../utilities/VideoPlayer'

import Link from 'next/link'
import { useRouter } from 'next/router'

const AUTH_STATUS = {
  success: 'success',
  fail: 'fail'
}

const ERROR_CODE = {
  deny: 'DENY',
  indeterminate: 'INDETERMINATE',
  notFound: 'NOT_FOUND',
  invalidParams: 'INVALID_PARAMS',
  timeout: 'TIMEOUT'
}

const errorMessage = new Map()
errorMessage.set(
  ERROR_CODE.deny,
  'It looks like News 12 is not included in your plan - contact your provider for more details'
)
errorMessage.set(ERROR_CODE.indeterminate, 'Something went wrong, please try again')
errorMessage.set(ERROR_CODE.notFound, 'News 12 was not found in your plan - contact your provider for more details')
errorMessage.set(ERROR_CODE.invalidParams, 'Something went wrong, our team is working to fix it')
errorMessage.set(ERROR_CODE.timeout, 'Request timed out, please try again')

const LoginError = ({ code }) => (
  <div>
    <p className='login-text'>
      {errorMessage.has(code) ? errorMessage.get(code) : errorMessage.get(ERROR_CODE.indeterminate)}
    </p>
    <style jsx>{loginError}</style>
  </div>
)

const Providers = ({ providers }) => {
  const query = useRouter()?.query

  return (
    <div className='wrapper-providers'>
      {(query?.status === AUTH_STATUS.fail || !providers?.length) && <LoginError code={query?.error} />}
      <h2>Select your TV provider</h2>
      <div className='container-providers' role='list'>
        {providers.map((p, i) => (
          <Link key={i} href={p.url} prefetch={false}>
            <img src={p.logo} alt={p.name} id={p.name} />
          </Link>
        ))}
      </div>
      <style jsx>{providerStyle}</style>
    </div>
  )
}

export default ({ livestream, providers }) => {
  return (
    <div className='wrapper'>
      <div className='screen'>
        {livestream?.url ? (
          <VideoPlayer src={livestream?.url} type='application/x-mpegURL' isLive={true} />
        ) : (
          <Providers providers={providers} />
        )}
      </div>
      <style jsx>{style}</style>
    </div>
  )
}
